module.exports = __webpack_public_path__ + "img/ISO9001-2015.d9e4c37b.jpg";